import { Css } from "~generated/css";

export function ErrorMessage({ message }: { message: string }) {
  return (
    <div css={Css.pb1.mt1.df.$}>
      <div css={Css.aic.mya.mr1.$}>
        <span css={Css.red600.$}>⚠</span>
      </div>
      <div css={Css.t14.red600.$}>{message}</div>
    </div>
  );
}
